"use client";

import { useEffect, useState } from "react";

export type DeviceType = "phone" | "tablet" | "laptop" | "desktop";

interface Breakpoints {
    phone: number;
    tablet: number;
    laptop: number;
}

export function useDeviceType(
    breakpoints: Breakpoints = { phone: 640, tablet: 1024, laptop: 1280 },
) {
    const [deviceType, setDeviceType] = useState<DeviceType | null>(null);

    useEffect(() => {
        const handleResize = () => {
            const width = window.screen.width;

            if (width < breakpoints.phone) {
                setDeviceType("phone");
            } else if (width < breakpoints.tablet) {
                setDeviceType("tablet");
            } else if (width < breakpoints.laptop) {
                setDeviceType("laptop");
            } else {
                setDeviceType("desktop");
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoints.phone, breakpoints.tablet, breakpoints.laptop]);

    return deviceType;
}
